import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import './Input.scss'

const Input = ({ placeholder, onChange, id, error, value, ariaLabel, maxLength = '', model, autoFocus, size, radius='all-rounded', type='text', name }) => (
    <input className={cx('input', error && 'error', model, size, radius)}
        aria-label={ariaLabel}
        autoFocus={autoFocus}
        id={id}
        maxLength={maxLength}
        onChange={onChange}
        placeholder={placeholder}
        type={type}
        value={value}
        name={name || id}
    />
);

Input.propTypes = {
    id: PropTypes.string,
    placeholder: PropTypes.string,
    error: PropTypes.bool,
    value: PropTypes.string,
    ariaLabel: PropTypes.string,
    maxLength: PropTypes.string,
    onChange: PropTypes.func,
    autoFocus: PropTypes.bool,
    model: PropTypes.oneOf(['outline', 'no-borders', 'secondary', 'success', 'alert', 'warning']),
    size: PropTypes.string,
    radius: PropTypes.oneOf(['half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded'])
}

export default Input



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/Input.jsx